import { Theme } from '@mui/material/styles'

// ==============================|| OVERRIDES - ALERT TITLE ||============================== //

export default function List(theme: Theme) {
  return {
    MuiList: {
      styleOverrides: {
        root: {
          // Main sidebar mini rail (layout/MainLayout/Drawer/DrawerContent/MiniDrawer) — no card frame
          '&:not([role="menu"]):not([role="listbox"]):not([data-sidebar-mini])': {
            padding: 0,
            borderRadius: 16,
            border: `1px solid ${theme.palette.primary.light}`,
            backgroundColor: theme.palette.primary.contrastText,
            paddingBottom: 24,
            '& .MuiListItem-root': {
              border: 0,
              padding: '0 24px',
              paddingTop: 24,
            },
            '& .MuiListSubheader-root': {
              paddingLeft: 24,
              borderBottom: `1px solid ${theme.palette.primary.light}`,
              backgroundColor: theme.palette.primary.lighter,
              color: theme.palette.primary.main,
              borderRadius: '16px 16px 0 0',
            },
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.primary.main,
          padding: 11,
          color: theme.palette.primary.contrastText,
          borderRadius: 8,
          fontSize: '1.1rem',
          minWidth: 34,
          marginRight: 10,
        },
      },
    },
  }
}
